import { render, staticRenderFns } from "./DataBase.vue?vue&type=template&id=568b327b&scoped=true"
import script from "./DataBase.vue?vue&type=script&lang=js"
export * from "./DataBase.vue?vue&type=script&lang=js"
import style0 from "./DataBase.vue?vue&type=style&index=0&id=568b327b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568b327b",
  null
  
)

export default component.exports